export default {
  admin: async () => null,
  sortable: async () => null,
}
